import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';
import axios from 'axios';

import DriverDTO from '../interfaces/driverDTO';
import { DriverRecordRequestService } from './driverrecordrequest.service';

@Injectable({
     providedIn: 'root'
})
export class DriverService {
     state = {
          authCode: '',
          recordStatus: '',
          error: {},
          driverProfile: {}
     };


     constructor(private http: HttpClient,
          private driverRecordRequestService: DriverRecordRequestService) {

     }

     getAuthCode(token: string) {
          let authMethod = 'Anonymous';
          const authenticatedUser = localStorage.getItem('username');
          if (authenticatedUser) {
               authMethod = 'Login.gov';
          }
          return this.driverRecordRequestService.getAuthCode('success', token, authMethod)
               .then((response: any) => {
                    if (response && response.isSuccess && response.authCode) {
                         localStorage.setItem('authCode', response.authCode);
                         this.state.authCode = response.authCode;
                         return response.authCode;
                    } else {
                         localStorage.setItem('authCode', '');
                         this.state.authCode = '';
                         return null;
                    }
               },
                    (error: any) => {
                         this.logError(error);
                         return Promise.reject(error);
                    }
               );
     }



     getStoredAuthCode() {
          return localStorage.getItem('authCode') || '';
     }

     clearAuthCode() {
          localStorage.setItem('authCode', '');
          this.state.authCode = '';
     }

     setDriverProfile(driverProfile: DriverDTO) {
          this.state.driverProfile = driverProfile;
     }

     logError(error: any) {
          console.error(error);
          this.state.error = error;
     }

     updateStatus(status: string) {
          this.state.recordStatus = status;
     }
}
